// frontend/src/services/accountService.js - CORRECTED VERSION
import api from './api';

const accountService = {
  // Account management
  getAccounts: async () => {
    try {
      const response = await api.get('/banking/accounts/');
      // Handle paginated response (returns {count, next, previous, results: [...]})
      return response.data.results || response.data || [];
    } catch (error) {
      console.error('Error fetching accounts:', error);
      return [];
    }
  },

  getAccount: async (accountId) => {
    try {
      const response = await api.get(`/banking/accounts/${accountId}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching account ${accountId}:`, error);
      throw error;
    }
  },

  getAccountBalance: async (accountId) => {
    try {
      const response = await api.get(`/banking/accounts/${accountId}/balance/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching account balance ${accountId}:`, error);
      throw error;
    }
  },

  createAccount: async (accountData) => {
    try {
      const response = await api.post('/banking/accounts/', accountData);
      return response.data;
    } catch (error) {
      console.error('Error creating account:', error);
      throw error;
    }
  },

  // Account features
  getAccountFeatures: async (accountId) => {
    try {
      const response = await api.get(`/banking/accounts/${accountId}/features/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching account features ${accountId}:`, error);
      // Return default features if endpoint doesn't exist
      return {
        international_transfer_enabled: true,
        daily_transfer_limit: 10000,
        requires_verification: true,
        max_beneficiaries: 10
      };
    }
  },

  updateAccountFeatures: async (accountId, features) => {
    try {
      const response = await api.put(`/banking/accounts/${accountId}/features/`, features);
      return response.data;
    } catch (error) {
      console.error(`Error updating account features ${accountId}:`, error);
      throw error;
    }
  },

  // Statement download
  downloadStatement: async (accountId) => {
    try {
      const response = await api.get(`/banking/accounts/${accountId}/statement/`, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      console.error(`Error downloading statement for account ${accountId}:`, error);
      throw error;
    }
  },

  // Deposit funds
  depositFunds: async (accountId, amount, description = 'Deposit') => {
    try {
      const response = await api.post(`/banking/accounts/${accountId}/deposit/`, {
        amount: amount,
        description: description
      });
      return response.data;
    } catch (error) {
      console.error(`Error depositing funds to account ${accountId}:`, error);
      throw error;
    }
  },

  // Transactions
  getTransactions: async () => {
    try {
      const response = await api.get('/banking/transactions/');
      return response.data.results || response.data || [];
    } catch (error) {
      console.error('Error fetching transactions:', error);
      return [];
    }
  },

  getRecentTransactions: async () => {
    try {
      const response = await api.get('/banking/transactions/recent/');
      return response.data.results || response.data || [];
    } catch (error) {
      console.error('Error fetching recent transactions:', error);
      return [];
    }
  },

  createTransfer: async (transferData) => {
    try {
      const response = await api.post('/banking/transactions/transfer/', transferData);
      return response.data;
    } catch (error) {
      console.error('Error creating transfer:', error);
      throw error;
    }
  },

  // Beneficiaries
  getBeneficiaries: async () => {
    try {
      const response = await api.get('/banking/beneficiaries/');
      return response.data.results || response.data || [];
    } catch (error) {
      console.error('Error fetching beneficiaries:', error);
      return [];
    }
  },

  createBeneficiary: async (beneficiaryData) => {
    try {
      const response = await api.post('/banking/beneficiaries/', beneficiaryData);
      return response.data;
    } catch (error) {
      console.error('Error creating beneficiary:', error);
      throw error;
    }
  },

  deleteBeneficiary: async (beneficiaryId) => {
    try {
      const response = await api.delete(`/banking/beneficiaries/${beneficiaryId}/`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting beneficiary ${beneficiaryId}:`, error);
      throw error;
    }
  },

  // Admin methods (only for admin users)
  adminGetAllAccounts: async () => {
    try {
      const response = await api.get('/banking/accounts/');
      return response.data.results || response.data || [];
    } catch (error) {
      console.error('Error fetching all accounts:', error);
      return [];
    }
  },

  adminUpdateAccountFeatures: async (accountId, features) => {
    try {
      const response = await api.put(`/banking/admin/account-features/${accountId}/`, features);
      return response.data;
    } catch (error) {
      console.error(`Error updating admin account features ${accountId}:`, error);
      throw error;
    }
  },
};

export default accountService;